import { Deserializable } from '../protocols/deserializable';
import { MonthlyPensionAnnuityCalculation } from './monthly-pension-annuity-calculation';

export class MonthlyPensionSingleLifeAnnuityCalculation implements Deserializable {
  public retirementDate!: string | null;
  public equity!: number;
  public memberBirthDate!: string | null;
  public memberAge!: number;
  public memberDaysUntilBirthDate!: number;
  public annuityCalculations!: MonthlyPensionAnnuityCalculation[];

  public onDeserialize(): void {
    this.annuityCalculations = window.injector.Deserialize.arrayOf(
      MonthlyPensionAnnuityCalculation,
      this.annuityCalculations
    );
  }
}
